import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { ApiService } from './services/api.service';
import { firstValueFrom } from 'rxjs';

export const purchaseRequestEditGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const service = inject(ApiService);
  
  const { purchaseRequestId } = route.params;

  const response: { hasPermission: boolean } = await firstValueFrom(service.hasPurchaseRequestEditorPermission(purchaseRequestId));
  if (response.hasPermission) 
    return true;
  else 
    return router.createUrlTree(['/dashboard']);
};
